import React, { useState } from 'react';
import { SMainContainer } from './styles';
import TopBar from '../../TopBar';
import Menu from '../../Menu';

const MainWrapper = ({ children, footer, menu }) => {
    const [openMenu, setOpenMenu] = useState(false);

    return (<>
        <SMainContainer maxWidth={false} disableGutters>
            <TopBar setOpenMenu={setOpenMenu} openMenu={openMenu} />
            {children}
        </SMainContainer>
        <Menu setOpenMenu={setOpenMenu} openMenu={openMenu} menu={menu} />
    </>)
}

export default MainWrapper;